import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Alert } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";

const { Option } = Select;

const formItemLayout = {
  labelCol: { xs: { span: 24 }, md: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, md: { span: 24 }, lg: { span: 12 } },
};

const MaterialCategoryAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [level1Categories, setLevel1Categories] = useState([]);
  const [level2Categories, setLevel2Categories] = useState([]);
  const [level3Categories, setLevel3Categories] = useState([]);
  const [level4Categories, setLevel4Categories] = useState([]);

  const [selectedLevel1Id, setSelectedLevel1Id] = useState(null);
  const [selectedLevel2Id, setSelectedLevel2Id] = useState(null);
  const [selectedLevel3Id, setSelectedLevel3Id] = useState(null);
  const [selectedLevel4Id, setSelectedLevel4Id] = useState(null);

  const [currentLevelText, setCurrentLevelText] = useState("Kategori (Seviye 1)");

  const getCategories = (parentId, level) => {
    let filter = "";
    if (level === 1) {
      filter = "ParentId eq null";
    } else {
      if (!parentId) return;
      filter = `ParentId eq ${parentId}`;
    }

    RequestHandler.get(`/MaterialCategory?$filter=${filter}`).then((response) => {
      if (response) {
        if (level === 1) setLevel1Categories(response.value);
        if (level === 2) setLevel2Categories(response.value);
        if (level === 3) setLevel3Categories(response.value);
        if (level === 4) setLevel4Categories(response.value);
      }
    });
  };

  useEffect(() => {
    getCategories(null, 1);
  }, []);

  const updateLevelText = (l1, l2, l3, l4) => {
    if (l4) setCurrentLevelText("Kategori (Seviye 5)");
    else if (l3) setCurrentLevelText("Kategori (Seviye 4)");
    else if (l2) setCurrentLevelText("Kategori (Seviye 3)");
    else if (l1) setCurrentLevelText("Kategori (Seviye 2)");
    else setCurrentLevelText("Kategori (Seviye 1)");
  };

  const handleLevel1Change = (value) => {
    setSelectedLevel1Id(value);
    setSelectedLevel2Id(null);
    setSelectedLevel3Id(null);
    setSelectedLevel4Id(null);
    setLevel2Categories([]);
    setLevel3Categories([]);
    setLevel4Categories([]);
    form.setFieldsValue({ level2Id: null, level3Id: null, level4Id: null });

    if (value) getCategories(value, 2);
    updateLevelText(value, null, null, null);
  };

  const handleLevel2Change = (value) => {
    setSelectedLevel2Id(value);
    setSelectedLevel3Id(null);
    setSelectedLevel4Id(null);
    setLevel3Categories([]);
    setLevel4Categories([]);
    form.setFieldsValue({ level3Id: null, level4Id: null });

    if (value) getCategories(value, 3);
    updateLevelText(selectedLevel1Id, value, null, null);
  };

  const handleLevel3Change = (value) => {
    setSelectedLevel3Id(value);
    setSelectedLevel4Id(null);
    setLevel4Categories([]);
    form.setFieldsValue({ level4Id: null });

    if (value) getCategories(value, 4);
    updateLevelText(selectedLevel1Id, selectedLevel2Id, value, null);
  };

  const handleLevel4Change = (value) => {
    setSelectedLevel4Id(value);
    updateLevelText(selectedLevel1Id, selectedLevel2Id, selectedLevel3Id, value);
  };

  const onSuccess = () => {
    form.resetFields();
    setSelectedLevel1Id(null);
    setSelectedLevel2Id(null);
    setSelectedLevel3Id(null);
    setSelectedLevel4Id(null);
    setLevel2Categories([]);
    setLevel3Categories([]);
    setLevel4Categories([]);
    setCurrentLevelText("Kategori (Seviye 1)");
    getCategories(null, 1);
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    let parentIdToSend = null;

    if (values.level4Id) parentIdToSend = values.level4Id;
    else if (values.level3Id) parentIdToSend = values.level3Id;
    else if (values.level2Id) parentIdToSend = values.level2Id;
    else if (values.level1Id) parentIdToSend = values.level1Id;

    const finalValues = {
      name: values.name,
      code: values.code,
      ParentId: parentIdToSend,
    };

    setLoading(true);
    RequestHandler.post(`/MaterialCategory`, finalValues).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="MaterialAdd"
      onFinish={onFinish}
    >
      <Row>
        <Col span={24}>
          <Row justify="center" style={{ marginBottom: 20 }}>
            <Col span={16}>
              <Alert message={`Şu an ekleyeceğiniz tür: ${currentLevelText}`} type="info" showIcon />
            </Col>
          </Row>

          <Form.Item label="Seviye 1 (Ana Kategori)" name="level1Id">
            <Select
              placeholder="Yok (Ana Kategori Olarak Ekle)"
              allowClear
              onChange={handleLevel1Change}
            >
              {level1Categories.map((cat) => (
                <Option key={cat.id} value={cat.id}>{cat.name}</Option>
              ))}
            </Select>
          </Form.Item>

          {selectedLevel1Id && (
            <Form.Item label="Seviye 2" name="level2Id">
              <Select
                placeholder="Yok (Seviye 2 Olarak Ekle)"
                allowClear
                onChange={handleLevel2Change}
              >
                {level2Categories.map((cat) => (
                  <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {selectedLevel2Id && (
            <Form.Item label="Seviye 3" name="level3Id">
              <Select
                placeholder="Yok (Seviye 3 Olarak Ekle)"
                allowClear
                onChange={handleLevel3Change}
              >
                {level3Categories.map((cat) => (
                  <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {selectedLevel3Id && (
            <Form.Item label="Seviye 4" name="level4Id">
              <Select
                placeholder="Yok (Seviye 4 Olarak Ekle)"
                allowClear
                onChange={handleLevel4Change}
              >
                {level4Categories.map((cat) => (
                  <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            label="Kategori Adı"
            name="name"
            rules={[{ required: true, message: "Lütfen isim giriniz." }]}
          >
            <Input placeholder="Örn: NYY Kablo" />
          </Form.Item>

          <Form.Item label="Kategori Kodu" name="code">
            <Input />
          </Form.Item>

          <Row justify="end">
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default MaterialCategoryAddForm;
